import { HttpStatusCode } from "axios"
import { getAuthedApi } from "../api/api"

export const addLike = async (jiraId: string) => {
    const authedApi = await getAuthedApi()
    const response = await authedApi.post(`api/v2.0/roadmap/jira-id/${jiraId}/like`)
    return response.status == HttpStatusCode.Created
}

export const removeLike = async (jiraId: string) => {
    const authedApi = await getAuthedApi()
    const response = await authedApi.delete(`api/v2.0/roadmap/jira-id/${jiraId}/like`)
    return response.status == HttpStatusCode.NoContent
}